<template>
  <div>
    <Slides v-bind:scrollingCards="scrollingCards" />
  </div>
</template>

<script>
import Slides from "@/components/Slides";

export default {
  name: "projects",

  components: { Slides },

  data: () => ({
    // Description of the Cards to show in the page
    scrollingCards: [
      {
        id: "1",
        class: "secondary",
        layoutColor: "",
        height: "50vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 1,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 10,
          lg: 10,
          xl: 10,
          textCardContainerClasses: "elevation-0",
          textCardContainerColor: "transparent",
          title: "projects.slide1.title",
          titleClasses: "text-left primary--text text-size-1 font-weight-light",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: 2,
          orderMd: 2,
          isOn: false,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "2",
        class: "bg-fixed bg-image-haveaseed",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "3",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 1,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide3.left.title",
          titleClasses:
            "text-no-wrap contrast--text text-left text-size-2 font-weight-light",
          subtitle: "projects.slide3.left.content",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: 2,
          orderMd: 2,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide3.right.subtitle",
          subtitleClasses:
            "text-left contrast--text text-size-3 font-weight-light",
          content: "projects.slide3.right.content",
          contentClasses:
            "text-left primary--text text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide3.right.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
      },
      {
        id: "4",
        class: "bg-fixed bg-image-logo",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "5",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 2,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16  my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide5.left.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "projects.slide5.left.content",
          contentClasses:
            "primary--text text-left text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide5.left.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
        right: {
          order: 1,
          orderMd: 2,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide5.right.title",
          titleClasses:
            "text-no-wrap text-left contrast--text text-size-2 font-weight-light",
          subtitle: "projects.slide5.right.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "6",
        class: "bg-fixed bg-image-ow",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "7",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 1,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide7.left.title",
          titleClasses:
            "text-no-wrap text-left contrast--text text-size-2 font-weight-light",
          subtitle: "projects.slide7.left.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: 2,
          orderMd: 2,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16  my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide7.right.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "projects.slide7.right.content",
          contentClasses:
            "primary--text text-left text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide7.right.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
      },
      {
        id: "8",
        class: "bg-fixed bg-image-cb",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "9",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 2,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16  my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide9.left.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "projects.slide9.left.content",
          contentClasses:
            "primary--text text-left text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide9.left.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
        right: {
          order: 1,
          orderMd: 2,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide9.right.title",
          titleClasses:
            "text-no-wrap text-left contrast--text text-size-2 font-weight-light",
          subtitle: "projects.slide9.right.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "10",
        class: "bg-fixed bg-image-UniCredit white",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "11",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide11.left.title",
          titleClasses:
            "text-no-wrap text-left contrast--text text-size-2 font-weight-light",
          subtitle: "projects.slide11.left.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16  my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide11.right.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "projects.slide11.right.content",
          contentClasses:
            "primary--text text-left text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide11.right.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
      },
      {
        id: "12",
        class: "bg-fixed bg-image-graph",
        height: "70vh",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
        right: {
          order: "",
          orderMd: "",
          isOn: false,
          cols: 10,
          md: 5,
          lg: 4,
          xl: 3,
          textCardContainerClasses: "",
          textCardContainerColor: "",
          title: "none",
          titleClasses: "",
          subtitle: "none",
          subtitleClasses: "",
          content: "none",
          contentClasses: "",
        },
      },
      {
        id: "13",
        class: "tertiary flat elevation-0 py-8",
        height: "",
        image: "none",
        imageClasses: "",
        justify: "space-around",
        left: {
          order: 2,
          orderMd: 1,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 6,
          xl: 7,
          textCardContainerClasses: "elevation-0 mb-16  my-md-16",
          textCardContainerColor: "transparent",
          title: "none",
          titleClasses: "",
          subtitle: "projects.slide13.left.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "projects.slide13.left.content",
          contentClasses:
            "primary--text text-left text-size-3 font-weight-light",
          overlayOn: "[true]",
          overlayColor: "tertiary",
          overlayOpacity: "1",
          overlayCardClasses:
            "elevation-0 transition-fast-in-fast-out v-card--reveal",
          overlayContent: "projects.slide13.left.overlayContent",
          overlayContentClasses:"text-left contrast--text text-size-3 font-weight-light"
        },
        right: {
          order: 1,
          orderMd: 2,
          isOn: true,
          cols: 10,
          md: 5,
          lg: 3,
          xl: 2,
          textCardContainerClasses: "elevation-0 mt-16 my-md-16",
          textCardContainerColor: "transparent",
          title: "projects.slide13.right.title",
          titleClasses:
            "text-no-wrap text-left contrast--text text-size-2 font-weight-light",
          subtitle: "projects.slide13.right.subtitle",
          subtitleClasses:
            "contrast--text text-left text-size-3 font-weight-light",
          content: "none",
          contentClasses: "",
        },
      },
    ],
  }),
};
</script>
